function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Prop, Component } from "vue-property-decorator";
import { State } from "vuex-class";
import { isSceneList } from "@/views/creative/utils";
import sceneBg from "@/assets/playturbo/scene_bg.png";
import { v2Host } from "@/config/host";
import { getApiPath } from "@/common/api-proxy";
var V2OutlineBd = /*#__PURE__*/ function(Vue1) {
    "use strict";
    _inherits(V2OutlineBd, Vue1);
    var _super = _createSuper(V2OutlineBd);
    function V2OutlineBd() {
        _classCallCheck(this, V2OutlineBd);
        var _this;
        _this = _super.apply(this, arguments);
        _this.isOpen = true;
        _this.subCategoryHeight = 0;
        _this.sceneBg = sceneBg;
        return _this;
    }
    var _proto = V2OutlineBd.prototype;
    _proto.mounted = function mounted() {
        if (this.isSceneList) {
            var _this = this;
            // 延迟计算高度，保证 UI 已渲染完成
            setTimeout(function() {
                _this.calculateSubCategoryHeight();
            }, 0);
        }
        window.addEventListener("resize", this.calculateSubCategoryHeight);
    };
    _proto.beforeDestroy = function beforeDestroy() {
        window.removeEventListener("resize", this.calculateSubCategoryHeight);
    };
    _proto.handleClick = function handleClick() {
        if (!this.isSceneList) {
            this.$emit("select", this.category);
        }
    };
    _proto.getScenesThumb = function getScenesThumb(item) {
        // url：截图地址，拿预览链接，加上参数 &scene=场景ID
        // t:  传 scene 表示场景截图
        if (this.previewUrl) {
            var preview = "".concat(this.previewUrl).concat(this.previewUrl.indexOf("?") > -1 ? "&" : "?", "scene=").concat(item.properties.uuid);
            return "".concat(v2Host).concat(getApiPath("/common/web/capture"), "?url=").concat(encodeURIComponent(preview), "&t=scene");
        }
        return sceneBg;
    };
    _proto.handleSubCategoryClick = function handleSubCategoryClick(cat) {
        this.$emit("select", cat);
    };
    _proto.toggleSubCategory = function toggleSubCategory() {
        this.isOpen = !this.isOpen;
        if (this.isOpen) {
            this.calculateSubCategoryHeight();
        }
    };
    _proto.calculateSubCategoryHeight = function calculateSubCategoryHeight() {
        var ele = this.$refs.category;
        var parentEle = ele.parentElement;
        var parentEleHeight = parentEle.clientHeight;
        var count = parentEle.children.length;
        var eleInner = ele.querySelector(".category-inner");
        this.subCategoryHeight = parentEleHeight - eleInner.clientHeight * count;
    };
    _createClass(V2OutlineBd, [
        {
            key: "isSceneList",
            get: function get() {
                return isSceneList(this.category.id);
            }
        }
    ]);
    return V2OutlineBd;
}(Vue);
__decorate([
    Prop({
        type: Object
    })
], V2OutlineBd.prototype, "category", void 0);
__decorate([
    State(function(state) {
        return state.creative.template.activeCategoryNode;
    })
], V2OutlineBd.prototype, "activeCategoryNode", void 0);
__decorate([
    State(function(state) {
        return state.creative.template.templateConfig.scenes_thumb || [];
    })
], V2OutlineBd.prototype, "scenesThumbs", void 0);
__decorate([
    State(function(state) {
        return state.creative.template.previewUrl || "";
    })
], V2OutlineBd.prototype, "previewUrl", void 0);
V2OutlineBd = __decorate([
    Component
], V2OutlineBd);
export { V2OutlineBd as default };
